<template>
    <div class="container">
      <div class="content">
        <h2>🌈 Paws & Plan Your Financial Dreams! 🌈</h2>
        <p>Each of these fabulous options represents a stage in your financial journey. Which one resonates with you?</p>
  
        <div class="option" @click="toggleOption('travel')" :class="{ selected: isSelected('travel') }">
          <span class="icon">🌍</span>
          <b>Travel the World:</b> Got wanderlust whiskers? Let's stash some cash for your next grand cat-venture!
        </div>
  
        <div class="option" @click="toggleOption('retire-early')" :class="{ selected: isSelected('retire-early') }">
          <span class="icon">🏖️</span>
          <b>Retire Early:</b> Dreaming of lounging in a sunbeam all day? Let's purr-pare for an early cat-nap retirement!
        </div>
  
        <div class="option" @click="toggleOption('own-home')" :class="{ selected: isSelected('own-home') }">
          <span class="icon">🏡</span>
          <b>Own or Upgrade my home:</b> Want a fancy litter palace or a cozy cat condo? Let's save for that purr-fect pad!
        </div>
  
        <div class="option" @click="toggleOption('emergency-fund')" :class="{ selected: isSelected('emergency-fund') }">
          <span class="icon">🚑</span>
          <b>Emergency Fund:</b> Life can sometimes toss a furball. Let's build a cushion for those unexpected cat-astrophes!
        </div>
  
        <div class="option" @click="toggleOption('education')" :class="{ selected: isSelected('education') }">
          <span class="icon">🎓</span>
          <b>Educational Goals:</b> Got your eyes on the prize? Let's make sure you're finan-cially set for your next learning leap!
        </div>
  
        <div class="option" @click="toggleOption('invest')" :class="{ selected: isSelected('invest') }">
          <span class="icon">💰</span>
          <b>Investments & Wealth Growth:</b> Want your coin stash to grow faster than catnip? Let's dive into the world of meow-nificent investments!
        </div>
  
        <div class="option" @click="toggleOption('unsure')" :class="{ selected: isSelected('unsure') }">
          <span class="icon">🎯</span>
          <b>Not exactly sure how to set your goals?</b>  Not to worry...that's what we are here to help you with!  🌟💰🗺️
        </div>
      </div>
    </div><br><br><br>
  </template>
  
  
  <script>
  import { onboardingStore } from '@/components/stores/onboardingStore'; // Adjust the path as necessary
  
  export default {
    setup() {
      const store = onboardingStore();
  
      const toggleOption = (option) => {
        // Check if the option is already selected
        const index = store.formData.onboarding_goals.indexOf(option);
        if (index === -1) {
          // If not selected, add it to the array
          store.updateFormData({ onboarding_goals: [...store.formData.onboarding_goals, option] });
        } else {
          // If already selected, remove it from the array
          const updatedGoals = store.formData.onboarding_goals.filter(item => item !== option);
          store.updateFormData({ onboarding_goals: updatedGoals });
        }
      };
  
      // Helper method to check if an option is selected
      const isSelected = (option) => store.formData.onboarding_goals.includes(option);
  
      return { store, toggleOption, isSelected };
    },
  };
  </script>





<style scoped>
.container {
  background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
}

.content {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  color: black;
}

.option {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  margin-bottom: 10px;
}

.option:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


.selected {
  background-color: #4A148C; /* More solid color for selection */
  color: white;
}


.icon {
  font-size: 24px; /* Larger icon size */
}

/* Additional style if needed */
</style>